/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
var COLLECTIONS_SELECTOR = 'data-collections-selector-collection-id';
function discoverMore() {
  var sliders = [];
  var discoversCarousel = document.querySelectorAll('[data-discover-carousel-collection]');
  discoversCarousel.forEach(function (discoverCarousel) {
    var flkty = new window.Flickity(discoverCarousel, {
      cellAlign: 'left',
      contain: false,
      pageDots: false,
      draggable: true,
      freeScroll: true,
      prevNextButtons: true
    });
    flkty.resize();
    document.addEventListener('DOMContentLoaded', function () {
      flkty.resize();
    });
    document.addEventListener('resize', function () {
      flkty.resize();
    });
    var discoverSelector = document.querySelector("[".concat(COLLECTIONS_SELECTOR, "=\"").concat(discoverCarousel.getAttribute('data-discover-carousel-collection'), "\"]"));
    var dataDiscoverScrollbar = document.querySelector("[data-discover-scrollbar=\"".concat(discoverCarousel.getAttribute('data-discover-carousel-collection'), "\"]"));
    discoverSelector.addEventListener('click', function () {
      var activeCollections = document.querySelectorAll('.active-collection');
      var activeSelectors = document.querySelectorAll('.active-discover-tab');
      var activeScrollbars = document.querySelectorAll('.active-scrollbar');
      activeSelectors.forEach(function (activeSelector) {
        activeSelector.classList.remove('active-discover-tab');
      });
      activeCollections.forEach(function (activeCollection) {
        activeCollection.classList.remove('active-collection');
      });
      activeScrollbars.forEach(function (activeScrollbar) {
        activeScrollbar.classList.remove('active-scrollbar');
      });
      discoverCarousel.classList.add('active-collection');
      discoverSelector.classList.add('active-discover-tab');
      dataDiscoverScrollbar.classList.add('active-scrollbar');
      flkty.resize();
    });
    sliders.push(flkty);
    var scrollBar = document.querySelector("[data-discover-scrollbar=\"".concat(discoverCarousel.getAttribute('data-discover-carousel-collection'), "\"]"));
    var scrollThumb = scrollBar.querySelector('.scroll-thumb');
    flkty.on('scroll', function (progress) {
      var currentProgress = Math.max(0, Math.min(1, progress));
      scrollThumb.style.width = "".concat(currentProgress * 100, "%");
    });
    var flicktySlider = discoverCarousel.querySelector('.flickity-slider');
    scrollBar.addEventListener('click', function (e) {
      var position = e.clientX - scrollBar.getBoundingClientRect().left;
      var percent = position / scrollBar.offsetWidth;
      var flicktyPosition = percent * flkty.slidesWidth;
      flicktySlider.style.transform = "translateX(-".concat(flicktyPosition, "px)");
      scrollThumb.style.width = "".concat(percent * 100, "%");
      flkty.x = -flicktyPosition;
    });
  });
  return {
    resize: function resize() {
      sliders.forEach(function (slider) {
        slider.resize();
        setTimeout(function () {
          slider.resize();
        }, 1000);
      });
    }
  };
}
var slider = discoverMore();
slider.resize();
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

/******/ })()
;